import RotacionAgenciaReportPage from "./RotacionAgenciaReportPage";

export {RotacionAgenciaReportPage}
export default RotacionAgenciaReportPage
